import React, { Component } from 'react';
import Firebase from 'firebase'
import $ from 'jquery'
import PropTypes from 'prop-types'
import moment from 'moment'
import "firebase/auth";

let propTypes = {
  isModalSuccess: PropTypes.func.isRequired
}

export default class SectionContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataContact: [],
      dataInput: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    this.props.isModalSuccess(false)
    Firebase.database().ref('contact').on('value', data => {
      this.setState({dataContact: data.val()})
    })
  }

  handleChange(e) {
    const {name, value} = e.target
    this.setState({
      dataInput: {
        ...this.state.dataInput, [name]: value
      }
    })
  }

  clickSend() {
    $('.contact-form').removeClass('animated fast shake')
    let {name, email, subject, message} = this.state.dataInput
    if (!name || !email || !subject || !message) {
      $('.contact-form').addClass('animated fast shake')
    } else {
      Firebase.auth().signInWithEmailAndPassword('clientpush@gmail.com', '123456')
      .catch(error => {
        console.error(error);
      })
      .then(res => {
        Firebase.database().ref('/').child('message').push(
          {
            'name': this.state.dataInput.name,
            'email': this.state.dataInput.email,
            'subject': this.state.dataInput.subject,
            'message': this.state.dataInput.message,
            'created': moment().format('YYYY-MM-DD HH:mm:ss'),
          }
        )
        this.setState({
          dataInput: {
            name: '',
            email: '',
            subject: '',
            message: ''
          }
        })
        Firebase.auth().signOut()
        this.props.isModalSuccess(true)
      })
    }
  }

  render() { 
    let {dataContact, dataInput} = this.state

    return (
      <section className="ftco-section contact-section ftco-no-pb" id="contact-section">
        <div className="container">
          <div className="row justify-content-center mb-5 pb-3">
            <div className="col-md-7 heading-section text-center" data-aos="fade-up">
              <span className="subheading">Contact</span>
              <h2 className="mb-4">Contact Us</h2>
              {/* <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</p> */}
            </div>
          </div>
          <div className="row block-9">
            <div className="col-md-7 order-md-last d-flex">
              <div className="bg-light p-4 p-md-5 contact-form">
                <div className="form-group">
                  <input
                    onChange={this.handleChange}
                    type="text"
                    className="form-control"
                    placeholder="Your Name"
                    value={dataInput.name || ''}
                    name="name"
                  />
                </div>
                <div className="form-group">
                  <input
                    onChange={this.handleChange}
                    type="text"
                    className="form-control"
                    placeholder="Your Email"
                    value={dataInput.email || ''}
                    name="email"
                  />
                </div>
                <div className="form-group">
                  <input
                    onChange={this.handleChange}
                    type="text"
                    className="form-control"
                    placeholder="Subject"
                    value={dataInput.subject || ''}
                    name="subject"
                  />
                </div>
                <div className="form-group">
                  <textarea
                    onChange={this.handleChange}
                    cols="30"
                    rows="7"
                    className="form-control"
                    placeholder="Message"
                    value={dataInput.message || ''}
                    name="message"
                  />
                </div>
                <div className="form-group">
                  <button className="btn btn-primary py-3 px-5" onClick={() => this.clickSend()}>
                    Send Message
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-5 d-flex">
              <div className="row d-flex contact-info mb-5">
                <div className="col-md-12" data-aos="fade-up" data-aos-delay="100">
                  <div className="box p-2 px-3 bg-light d-flex">
                    <div className="icon mr-3">
                      <span className="icon-map-signs"></span>
                    </div>
                    <div>
                      <h3 className="mb-3">Address</h3>
                      <p>{dataContact.address}</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12" data-aos="fade-up" data-aos-delay="200">
                  <div className="box p-2 px-3 bg-light d-flex">
                    <div className="icon mr-3">
                      <span className="icon-phone2"></span>
                    </div>
                    <div>
                      <h3 className="mb-3">Contact Number</h3>
                      <p><a href={`tel://${dataContact.phone}`}>{dataContact.phone}</a></p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12" data-aos="fade-up" data-aos-delay="300" data-aos-offset="-50">
                  <div className="box p-2 px-3 bg-light d-flex">
                    <div className="icon mr-3">
                      <span className="icon-paper-plane"></span>
                    </div>
                    <div>
                      <h3 className="mb-3">Email Address</h3>
                      <p><a href={`mailto:${dataContact.email}`}>{dataContact.email}</a></p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12" data-aos="fade-up" data-aos-delay="400" data-aos-offset="-50">
                  <div className="box p-2 px-3 bg-light d-flex">
                    <div className="icon mr-3">
                      <span className="icon-whatsapp" style={{fontSize: '20px'}}></span>
                    </div>
                    <div>
                      <h3 className="mb-3">Whatsapp</h3>
                      <p><a href={`https://api.whatsapp.com/send?phone=${dataContact.whatsapp}`} target="_blank">{dataContact.whatsapp}</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

SectionContact.propTypes = propTypes;